import { createRecipe } from './runtime.js';

const containerLayoutConfig = {"name":"containerLayout"}

export const containerLayout = /* @__PURE__ */ createRecipe(containerLayoutConfig)